import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";

import { StyleProvider } from "@ant-design/cssinjs";
import { ConfigProvider } from "antd";
import IconContext from "@ant-design/icons/es/components/Context";

function getCspNonce(): string | undefined {
  const meta = document.querySelector(
    'meta[name="csp-nonce"]',
  ) as HTMLMetaElement | null;
  return meta?.content || (window as any).__CSP_NONCE__;
}

const nonce = getCspNonce();
const rootElement = document.getElementById("root");

if (!rootElement) throw new Error("No root found!");

if (import.meta.env.NODE_ENV === "production") {
  console.log = () => {};
  console.warn = () => {};
  console.error = () => {};
}

if (import.meta.env.NODE_ENV === "development") {
  // eslint-disable-next-line no-console
  console.log("dev mode");
}

const app = (
  <StrictMode>
    {/* In v1.24.0: kein nonce-Prop hier */}
    <StyleProvider>
      {nonce ? (
        <ConfigProvider csp={{ nonce }}>
          <IconContext.Provider value={{ csp: { nonce } }}>
            <App />
          </IconContext.Provider>
        </ConfigProvider>
      ) : (
        <App />
      )}
    </StyleProvider>
  </StrictMode>
);

if (!rootElement.innerHTML) {
  createRoot(rootElement).render(app);
}
